import React from 'react';
import { Map } from 'immutable';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import classNames from 'classnames';
import EditableRTECell from 'main/components/show/cuesheet/editableRTECell.jsx';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import FDTPropUpdateFixMixin from 'main/components/show/cuesheet/FDTPropUpdateFixMixin';
import { getDefaultRTEState } from 'shared/lib/rteHelper';

/**
 * Note cell
 *
 */
export default React.createClass({
  displayName: 'NoteCell',

  mixins: [HighlightCellMixin, FDTPropUpdateFixMixin],

  propTypes: {
    item: React.PropTypes.object.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    isCopied: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
    widthClassName: React.PropTypes.string,
  },

  render() {
    const {
      isEditing,
      isSelected,
      isCopied,
      widthClassName,
      rowIndex,
    } = this.props;

    let wrapperClasses = classNames('cs-note-cell-wrapper');

    const cellClasses = classNames(
      'cs-note-cell',
      widthClassName,
      {
        'cs-cell-editing': isEditing,
        'cs-cell-selected': isSelected,
        'cs-cell-copied': isCopied,
      },
      this.getPersonalHighlightClass(),
    );

    return (
      <div className={wrapperClasses}>
        <EditableRTECell
          keyPrefix={'row-' + rowIndex + '-note'}
          allowMarkdown
          format={this._getCellFormat()}
          onSelect={this._select}
          onStartEdit={this._startEditing}
          onStopEdit={this._stopEditing}
          rteState={this._getCellState()}
          resizeWhenEditing
          style={Object.assign(
            {},
            this.getGlobalHighlightStyle(),
            this.getPersonalHighlightStyle(),
          )}
          extraClassName={cellClasses}
          {...this.props}
        />
      </div>
    );
  },

  _getUserSettings() {
    const { item } = this.props;
    return item.get('userSettings');
  },

  _getCellFormat() {
    const { userId } = this.props;

    const userSettings = this._getUserSettings();

    const path = [userId, 'note', 'format'];

    if (userSettings && userSettings.getIn(path)) {
      return userSettings.getIn(path);
    }
  },

  _getCellState() {
    const { userId } = this.props;

    const userSettings = this._getUserSettings();
    const path = [userId, 'note', 'rteState'];

    if (userSettings && userSettings.getIn(path)) {
      return userSettings.getIn(path);
    }

    return getDefaultRTEState();
  },

  _select() {
    const { rowIndex } = this.props;
    CuesheetCellActions.selectItemCell(rowIndex, EditableCellTypes.ItemNote);
  },

  _startEditing() {
    const { rowIndex } = this.props;
    CuesheetCellActions.startEditingItemCell(
      rowIndex,
      EditableCellTypes.ItemNote,
    );
  },

  _stopEditing(rteState, rowId) {
    const cellSpec = Map({
      type: EditableCellTypes.ItemNote,
      value: EditableCellTypes.ItemNote,
    });

    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);
  },
});
